const translations: any = {
    Search: 'Tìm',
    'All categories': 'Tất cả ngành nghề',
    'View more': 'Xem thêm',
    'No results found': 'Không có kết quả',
    'There is no company matches with your search': 'Từ khoá tìm kiếm của bạn không khớp với tên công ty nào',
    'We found': 'Chúng tôi tìm thấy',
    'companies matching with': 'công ty phù hợp với',
    'company matching with': 'công ty phù hợp với',
    'category': 'ngành',
    'categories': 'ngành',
    'industries': 'lĩnh vực',
    'industry': 'lĩnh vực',
    'Clear filter': 'Xoá bộ lọc'
}

export default translations
